import { createContext } from 'react';
import { SelectionType } from '@philips-internal/oswald-ui-constants';
import { BaseCardListContext } from '../base-card-list/base-card-list-context.js';
class DeckContext extends BaseCardListContext {
    constructor() {
        super(...arguments);
        /**
         * Returns whether it is allowed to select multiple groups.
         *
         * @param selectionType - Deck property that dictates the type of selection.
         */
        this.allowMultipleGroupsSelection = (type) => {
            return this.isMultipleType(type);
        };
        /**
         * Returns a new set of selected groups, based on the type of selection or whether to remove an group from the selection.
         *
         * @param args - Arguments to build new selection.
         */
        this.modifyGroupSelection = (args) => {
            const { item, remove, selection, type } = args;
            if (remove) {
                return selection.filter(oldItem => oldItem !== item);
            }
            const multiSelection = this.isMultipleType(type);
            return multiSelection ? [...selection, item] : [item];
        };
    }
    /**
     * Returns whether it is allowed to select groups.
     *
     * @param selectable - Deck property that dictates whether it is selectable.
     * @param selectionType - Deck property that dictates the type of selection.
     */
    allowGroupSelection(selectable, selectionType) {
        return selectable && ![SelectionType.NONE, SelectionType.SINGLE].includes(selectionType);
    }
    /**
     * Returns whether it is allowed to trigger a group selection event.
     *
     * @param selectionType - Deck property that dictates the type of selection.
     */
    allowGroupSelectionEvent(type) {
        return [SelectionType.MULTIPLE_GROUP, SelectionType.SINGLE_GROUP].includes(type);
    }
    /**
     * Returns if the group is selected.
     *
     * @param groupKey Group identifier.
     * @param selectionType - Deck property that dictates the type of selection.
     */
    isGroupSelected(groupKey, selectedGroups) {
        return selectedGroups.includes(groupKey);
    }
    /**
     * Returns if the selection type is multiple.
     *
     * @param type Selection type
     */
    isMultipleType(type) {
        return [SelectionType.MULTIPLE, SelectionType.MULTIPLE_GROUP].includes(type);
    }
}
DeckContext.Context = createContext(new DeckContext());
export default DeckContext;
//# sourceMappingURL=deck-context.js.map